import * as SettingsUI from '../SettingsUI';
import React from 'react';
import LlmSettingsForm from './LlmSettingsForm';

const LlmSettings = () => {
  return (
    <SettingsUI.SettingsSection>
      <SettingsUI.Title>AI Settings</SettingsUI.Title>
      <LlmSettingsForm />
    </SettingsUI.SettingsSection>
  );
};

export default LlmSettings;
